import { Navbar } from "../shared/components/Navbar.js";
import { AuthService } from "../shared/services/AuthService.js";
import { ApiService } from "../shared/services/ApiService.js";
import { AppConfig } from "../shared/config/AppConfig.js";
import { AdjuntosService } from "../shared/services/AdjuntosService.js";
import { LocationSelectModule } from "../shared/components/LocationSelectModule.js";

import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import quotesTemplate from "./templates/quotes.html?raw";
import quoteCreateTemplate from "./templates/quote-create.html?raw";
import quoteCotizacionesTemplate from "./templates/quote-cotizaciones.html?raw";
import addPartTemplate from "./templates/add-part-modal.html?raw";

import Swal from "sweetalert2";

export const QuotesController = {

	siteNamePublicidad: AppConfig.app.name,
	seccionPublicidad: "presupuestos",
	isSending: false,

	render: async () => {
		try {
			const user = AuthService.getCurrentUser();

			const [quotesResp, adsHeader] = await Promise.all([
				ApiService.post("apiapp/ObtenerPresupuestos", null, user?.token),
				ApiService.get(`apiapp/obtenerpublicidad?sector=1&seccion=${QuotesController.seccionPublicidad}&sitio=${QuotesController.siteNamePublicidad}&cantidad=1`),
			]);

			const adsHeaderItem = (adsHeader.ads || []).length > 0 ? adsHeader.ads[0].item : null;

			const quotes = quotesResp?.message?.Cotizaciones || [];
			const requests = quotesResp?.message?.Solicitudes || [];

			
			

			const formattedQuotes = quotes.map((quote) => {
				return {
					...quote,
					FechaPresupuesto: QuotesController.parseDotNetDate(quote.FechaPresupuesto).toLocaleDateString("es-AR"),
					FechaValidez: QuotesController.parseDotNetDate(quote.FechaValidez).toLocaleDateString("es-AR"),
					FechaCotizacion: QuotesController.parseDotNetDate(quote.FechaCotizacion).toLocaleDateString("es-AR"),
					CotizacionMenor: new Intl.NumberFormat("es-AR", {
						style: "currency",
						currency: "ARS",
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}).format(quote.CotizacionMenor),
					canEdit: quote.Estado === "new" || quote.Estado === "pending",
					escotizacion: 'si',
				};
			});

			const vehicles = [
				...new Map(
					quotes.map(q => [
						`${q.VehiMarca} ${q.VehiModelo} - ${q.Dominio}`,
						{
							vehiculo: `${q.VehiMarca} ${q.VehiModelo} - ${q.Dominio}`,
							Dominio: q.Dominio
						}
					])
				).values()
			];

			const formattedRequests = requests.map((req) => {
				return {
					...req,
					FechaPresupuesto: QuotesController.parseDotNetDate(req.FechaPresupuesto).toLocaleDateString("es-AR"),
					FechaValidez: QuotesController.parseDotNetDate(req.FechaValidez).toLocaleDateString("es-AR"),
					FechaCotizacion: QuotesController.parseDotNetDate(req.FechaCotizacion).toLocaleDateString("es-AR"),
					CotizacionMenor: req.CotizacionMenor
						? new Intl.NumberFormat("es-AR", {
							style: "currency",
							currency: "ARS",
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						}).format(req.CotizacionMenor)
						: null,
					escotizacion: 'no',
				};
			});

			formattedQuotes.push(...formattedRequests);
			
			const data = {
				quotes: formattedQuotes,
				hasQuotes: formattedQuotes.length > 0,
				vehicles: vehicles,
				adsHeader: adsHeaderItem,
			};

			const content = TemplateEngine.render(quotesTemplate, data);
			document.getElementById("app").innerHTML = await Navbar.render() + content;

			QuotesController.setupFilters();
			QuotesController.bindingEvents();




			const hash = window.location.hash.slice(1) || "";
			const [path, queryString] = hash.split("?");
			const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams();
			const pideNew = params.get("new");
			if (pideNew === "1") {
				// eliminar el parámetro para que no vuelva a ejecutarse
				params.delete("new");
				window.location.hash = path + (params.toString() ? "?" + params.toString() : "");
				QuotesController.selectorVehiculoNewQuote();
			}


		} catch (error) {
			console.error("Error loading quotes:", error);
			document.getElementById("app").innerHTML =
				Navbar.render() +
				`<div class="container mt-4">
          <div class="alert alert-danger">Error al cargar los presupuestos</div>
        </div>`;
		}
	},

	bindingEvents: () => {
		document.getElementById("btnNewPresupuesto").addEventListener("click", QuotesController.selectorVehiculoNewQuote);

		const btnFirst = document.querySelector(".firstQuote");
		if (btnFirst) {
			btnFirst.addEventListener("click", QuotesController.selectorVehiculoNewQuote);
		}

		const detailButtons = document.querySelectorAll(".btnVer");
		detailButtons.forEach((button) => {
			button.addEventListener("click", () => {
				const quotecode = button.dataset.quotecode;
				const cotizacion = button.dataset.cotizacion;
				QuotesController.verCotizaciones(quotecode, cotizacion);
			});
		});

		const deleteButtons = document.querySelectorAll(".btnBorrar");
		deleteButtons.forEach((button) => {
			button.addEventListener("click", () => {
				const quotecode = button.dataset.quotecode;
				const cotizacion = button.dataset.cotizacion;
				QuotesController.deleteQuote(quotecode, cotizacion);
			});
		});


	},

	populateSelect: (selectId, options) => {
		const select = document.getElementById(selectId);
		// Limpiar opciones existentes (excepto la primera)
		while (select.children.length > 1) {
			select.removeChild(select.lastChild);
		}

		options.forEach((option) => {
			const optionElement = document.createElement("option");
			optionElement.value = option.id;
			optionElement.textContent = option.name;
			select.appendChild(optionElement);
		});
	},

	parseDotNetDate: (val) => {
		if (!val) return "";
		const match = /Date\((\d+)\)/.exec(val);
		return match ? new Date(parseInt(match[1], 10)) : new Date(val);
	},


	setupFilters: () => {
		const searchInput = document.getElementById("searchQuote");
		const statusFilter = document.getElementById("filterStatus");
		const vehicleFilter = document.getElementById("filterVehicle");

		if (searchInput) {
			searchInput.addEventListener("input", QuotesController.applyFilters);
		}
		if (statusFilter) {
			statusFilter.addEventListener("change", QuotesController.applyFilters);
		}
		if (vehicleFilter) {
			vehicleFilter.addEventListener("change", QuotesController.applyFilters);
		}
	},

	applyFilters: () => {
		const searchTerm = document.getElementById("searchQuote")?.value.toLowerCase() || "";
		const statusFilter = document.getElementById("filterStatus")?.value || "";
		const vehicleFilter = document.getElementById("filterVehicle")?.value || "";

		const rows = document.querySelectorAll(".quote-row");

		rows.forEach((row) => {
			const text = row.textContent.toLowerCase();
			const matchesSearch = text.includes(searchTerm);

			let matchesStatus = true;
			if (statusFilter) {
				const statusBadge = row.querySelector(`[class*="status-badge-${statusFilter}"]`);
				matchesStatus = statusBadge !== null;
			}
			let matchesVehicle = true;
			if (vehicleFilter) {
				const vehicleBadge = row.querySelector(`[class*="vehicle-plate"]`);
				matchesVehicle = vehicleBadge?.textContent.includes(vehicleFilter);
			}

			const shouldShow = matchesSearch && matchesStatus && matchesVehicle;
			row.style.display = shouldShow ? "" : "none";
		});
	},

	deleteQuote: async (codigo, cotizacion) => {
		const result = await Swal.fire({
			title: "¿Eliminar presupuesto?",
			text: "Esta acción no se puede deshacer",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sí, eliminar",
			cancelButtonText: "Cancelar",
			confirmButtonColor: "#dc3545",
		});

		if (result.isConfirmed) {
			try {
				const user = AuthService.getCurrentUser();
				const delPresupuesto = await ApiService.post("apiapp/AnularPresupuesto", { Codigo: codigo, Cotizacion: cotizacion == 'si' }, user?.token);
				if (delPresupuesto?.status != 1) {
					throw new Error("Error deleting quote");
				}
				await Swal.fire("Eliminado", "El presupuesto ha sido eliminado", "success");
				QuotesController.render();
			} catch (error) {
				Swal.fire("Error", "No se pudo eliminar el presupuesto", "error");
			}
		}
	},

	verCotizaciones: async (codigo, cotizacion) => {
		try {
			const user = AuthService.getCurrentUser();

			const [objPresupuesto, adsPop] = await Promise.all([
				ApiService.post("apiapp/ObtenerPresupuestoXCodigo", { Codigo: codigo, Cotizacion: cotizacion == 'si' }, user?.token),
				ApiService.get(`apiapp/obtenerpublicidad?sector=2&seccion=${QuotesController.seccionPublicidad}&sitio=${QuotesController.siteNamePublicidad}&cantidad=1`),
			]);

			const quote = objPresupuesto?.message;
			if (!quote) {
				Swal.fire("Error", "Presupuesto no encontrado", "error");
				return;
			}

			const adsPopItem = (adsPop.ads || []).length > 0 ? adsPop.ads[0].item : null;

			const data = {
				...quote,
				FechaPresupuesto: QuotesController.parseDotNetDate(quote.FechaPresupuesto).toLocaleDateString("es-AR"),
				FechaValidez: QuotesController.parseDotNetDate(quote.FechaValidez).toLocaleDateString("es-AR"),
				Cotizaciones: quote.Cotizaciones?.map(c => ({
					...c,
					MasBarato: c.ImporteTotal === quote.CotizacionMenor,
					ImporteFormateado: new Intl.NumberFormat("es-AR", {
						style: "currency",
						currency: "ARS",
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}).format(c.ImporteTotal)
				})),
				adsPop: adsPopItem
			};

			const modalContent = TemplateEngine.render(quoteCotizacionesTemplate, data);

			await Swal.fire({
				title: false,
				html: modalContent,
				width: 800,
				showCancelButton: false,
				confirmButtonText: "Cerrar",
			});
		} catch (error) {
			console.error("Error viewing quote:", error);
			Swal.fire("Error", "No se pudo cargar el presupuesto o las cotizaciones", "error");
		}
	},

	selectorVehiculoNewQuote: async () => {

		const handled = await QuotesController.validacionPresupuestoPapelera();
		if (handled) return;

		try {
			const user = AuthService.getCurrentUser();
			const vehiclesResponse = await ApiService.post("apiapp/ObtenerVehiculos", null, user?.token);
			const vehicles = vehiclesResponse.vehiculos;

			if (vehicles.length === 0) {
				Swal.fire({
					title: "Sin Vehículos",
					text: "Primero debes agregar un vehículo para solicitar presupuestos",
					icon: "warning",
					confirmButtonText: "Ir a Vehículos",
				}).then((result) => {
					if (result.isConfirmed) {
						window.location.hash = "vehicles";
					}
				});
				return;
			}

			const storedDominio = localStorage.getItem("ServiceToVehicle");
			const dominioValido = vehicles.some(v => v.Dominio === storedDominio);

			const vehicleOptions = vehicles
				.map(v => {
					const selected = dominioValido && v.Dominio === storedDominio
						? "selected"
						: "";
					return `<option value="${v.Dominio}" ${selected}>
					${v.Marca} ${v.Modelo} - ${v.Dominio}
				</option>`;
				})
				.join("");

			const result = await Swal.fire({
				title: '<i class="fas fa-plus-circle me-2"></i>Nuevo Presupuesto',
				html: `
          <form class="text-start" id="newQuoteForm">
            <div class="mb-3">
              <label class="form-label">Vehículo *</label>
              <select class="form-select" name="Vehiculo" required>
                <option value="">Seleccionar vehículo...</option>
                ${vehicleOptions}
              </select>
            </div>
            
            <div class="mb-1">
              <label class="form-label">Fecha de Vencimiento *</label>
              <input type="date" class="form-control" name="expirationDate"
                     min="${new Date().toISOString().split("T")[0]}" value="${new Date(new Date().setDate(new Date().getDate() + 10)).toISOString().split("T")[0]}" required>
            </div>
            <div class="form-text text-muted small mb-4 form-tip">
              💡 Es la fecha límite hasta la cual vas a recibir presupuestos.
            </div>

			
				<div class="mb-3">
					<label class="form-label">País *</label>
					<select class="form-select" name="ZonaIdPais" id="selectPais" required>
						<option value="">Seleccionar país</option>
					</select>
				</div>
				<div class="mb-3">
					<label class="form-label">Provincia *</label>
					<select class="form-select" name="ZonaIdProvincia" id="selectProvincia"
						required disabled>
						<option value="">Seleccionar provincia</option>
					</select>
				</div>

				<div class="mb-3">
					<label class="form-label">Localidad *</label>
					<select class="form-select" name="ZonaIdLocalidad" id="selectLocalidad"
						required disabled>
						<option value="">Seleccionar localidad</option>
					</select>
				</div>
                                    
            
            
          </form>
        `,
				width: 500,
				showCancelButton: true,
				confirmButtonText: "Crear",
				cancelButtonText: "Cancelar",
				didOpen: async () => {
					// Cargar paises
					await LocationSelectModule.mount({
						root: document,
						selectPais: "#selectPais",
						selectProvincia: "#selectProvincia",
						selectLocalidad: "#selectLocalidad",
						loadSavedLocation: true,
					});
				},
				preConfirm: () => {
					const form = document.getElementById("newQuoteForm");
					const formData = new FormData(form);
					return Object.fromEntries(formData);
				},
			});

			if (result.isConfirmed) {
				const vehi = vehicles.find(v => v.Dominio === result.value.Vehiculo);

				if (!vehi) {
					Swal.fire("Error", "Vehículo inválido o no encontrado", "error");
					return;
				}

				const data = {
					IdVehiculoReal: vehi.IdVehiculoReal,
					IdVehiculo: vehi.IdVehiculo,
					Dominio: result.value.Vehiculo,
					Marca: vehi.Marca,
					Modelo: vehi.Modelo,
					Vehiculo: `${vehi.Marca} ${vehi.Modelo} - ${vehi.Dominio}`,
					expirationDate: result.value.expirationDate,
					ZonaIdPais: result.value.ZonaIdPais || 0,
					ZonaIdProvincia: result.value.ZonaIdProvincia || 0,
					ZonaIdLocalidad: result.value.ZonaIdLocalidad || 0,
					items: [],
				};


				localStorage.setItem("newQuoteData", JSON.stringify(data));
				await QuotesController.popupPresupuesto();
			}
		} catch (error) {
			console.error("Error creating quote:", error);
			Swal.fire("Error", "No se pudo crear el presupuesto", "error");
		}

		return;
	},

	validacionPresupuestoPapelera: async () => {

		const dataStorage = JSON.parse(localStorage.getItem("newQuoteData")) || [];

		if (dataStorage && dataStorage.items && dataStorage.items.length > 0) {
			const result = await Swal.fire({
				title: "Continuar Presupuesto",
				text: "Tienes un presupuesto en proceso. ¿Deseas continuar con él?",
				icon: "question",
				showCancelButton: true,
				confirmButtonText: "Sí, continuar",
				cancelButtonText: "No, empezar nuevo",
			});

			if (result.isConfirmed) {
				await QuotesController.popupPresupuesto();
				return true;
			}
			localStorage.removeItem("newQuoteData");

		}

		return false;
	},

	popupPresupuesto: async () => {
		const dataCabecera = JSON.parse(localStorage.getItem("newQuoteData")) || [];
		dataCabecera.itemsCount = dataCabecera.items ? dataCabecera.items.length : 0;
		const modalContent = TemplateEngine.render(quoteCreateTemplate, dataCabecera);

		const result = await Swal.fire({
			title: false,
			html: modalContent,
			width: 800,
			showCancelButton: true,
			cancelButtonText: "Cancelar",
			confirmButtonText: "Generar Presupuesto",
			didOpen: () => {
				document.getElementById("btnAddPieza").addEventListener("click", () => {
					QuotesController.showAddPartModal(dataCabecera.IdVehiculo); // Pass the vehicle ID
				});

				const deleteButtons = document.querySelectorAll(".btnEliminarItem");
				deleteButtons.forEach((button) => {
					button.addEventListener("click", async () => {
						const itemId = button.dataset.itemid;
						QuotesController.quitarItem(itemId);
					});
				});
			},
			preConfirm: () => {
				return true;
			},
		});

		if (result.isConfirmed) {
			await QuotesController.enviarPresupuestoToApi();
		}
	},

	enviarPresupuestoToApi: async () => {

		if (QuotesController.isSending) return;
		QuotesController.isSending = true;


		try {

			const dataStorage = JSON.parse(localStorage.getItem("newQuoteData")) || [];
			if (!dataStorage || !dataStorage.items || dataStorage.items.length === 0) {
				await Swal.fire("Error", "Debes agregar al menos una pieza al presupuesto", "error");
				await QuotesController.popupPresupuesto();
				return;
			}
			const user = AuthService.getCurrentUser();

			let adjuntosQS = "";

			const result = await Swal.fire({
				title: "¿Querés adjuntar imágenes?",
				text: "Podés subir hasta 6 fotos.",
				icon: "question",
				showCancelButton: true,
				confirmButtonText: "Sí, adjuntar",
				cancelButtonText: "No, continuar",
				reverseButtons: true,
			});

			const quiereAdjuntar = result.isConfirmed;

			if (quiereAdjuntar) {
				const nombresAdjuntos = await AdjuntosService.openUploaderModal({
					token: user?.token,
					max: 6
				});

				// cerró la pantalla -> no enviar nada
				if (nombresAdjuntos === null) return;

				// canceló -> enviar sin adjuntos
				adjuntosQS = AdjuntosService.buildAdjuntosQuery(nombresAdjuntos);
			}

			const presupToApi = {
				IdPersona: user?.id,
				NroSiniestro: "",
				IdVehiculoReal: dataStorage.IdVehiculoReal,
				DiasValidez: Math.ceil((new Date(dataStorage.expirationDate) - new Date()) / (1000 * 60 * 60 * 24)),
				ZonaIdPais: dataStorage.ZonaIdPais || 0,
				ZonaIdProvincia: dataStorage.ZonaIdProvincia || 0,
				ZonaIdLocalidad: dataStorage.ZonaIdLocalidad || 0,
				IdVehiculoReal: dataStorage.IdVehiculoReal,
				PrestadoresPresupuestos_Det: dataStorage.items.map((item) => ({
					Id: 0,
					IdServicio: 0,
					IdPieza: item.partId,
					Cantidad: item.quantity,
					Descripcion: item.description,
					S: 1,
				})),
			};
			const objPresupuesto = await ApiService.post(`apiapp/Presupuesto?Adjuntos=${encodeURIComponent(adjuntosQS)}`, presupToApi, user?.token);
			if (objPresupuesto?.status < 1) {
				throw new Error("Error enviando datos de presupuesto a la API");
			}

			localStorage.removeItem("newQuoteData");

			await Swal.fire({
				html: `
					<h2>Presupuesto creado correctamente.</h2> 
					<p>Espera a la fecha de vencimiento para ver las cotizaciones en la sección de presupuestos.</p>
					<p class="text-muted">El código de presupuesto es: </p>
					<p class="text-muted">${objPresupuesto?.message?.Codigo}</p>
					`,
				icon: "success",
			});

			QuotesController.render();

		} catch (error) {
			console.error("Error creating quote:", error);
			await Swal.fire("Error", "No se pudo crear el presupuesto", "error");
		} finally {
			QuotesController.isSending = false;
		}
	},

	showAddPartModal: async (vehicleId) => {
		try {
			const catSelected = 1;
			const user = AuthService.getCurrentUser();
			const categories = await ApiService.get("PiezaSectores/obtener");
			const parts = await ApiService.post("vehiculos/ObtenerPiezasPorIdVehiculo_Y_Sector", { IdSector: catSelected, IdVehiculo: vehicleId }, user?.token);

			const catMap = categories.message.map(c => ({
				id: c.id,
				name: c.nombre,
				description: c.nombre,
			}));


			const partMap = parts.message.map(p => ({
				id: p.pieza_id,
				code: p.NumeroPieza,
				name: p.Descripcion || "",
				description: p.Descripcion || "",
				categoryId: catSelected,
				category: catMap.find(c => c.id === catSelected)?.name || "General",
			}));

			const data = {
				categories: catMap,
				parts: partMap,
			};

			const modalContent = TemplateEngine.render(addPartTemplate, data);

			const result = await Swal.fire({
				title: '<i class="fas fa-plus-circle me-2"></i>Agregar Pieza',
				html: modalContent,
				width: 800,
				showCancelButton: true,
				confirmButtonText: "Agregar",
				cancelButtonText: "Cancelar",
				didOpen: () => {
					QuotesController.setupAddPartModal();
				},
				preConfirm: () => {
					return QuotesController.getSelectedParts();
				},
			});

			if (result.isConfirmed) {
				QuotesController.addPartsToQuote(result.value);
			}

		} catch (error) {
			console.error("Error loading parts:", error);
			Swal.fire("Error", "No se pudieron cargar las piezas", "error");
		}
	},

	setupAddPartModal: () => {
		const categorySelect = document.getElementById("partCategorySelect");
		const searchInput = document.getElementById("searchPartInput");
		const partsTableBody = document.getElementById("partsTableBody");
		const checkboxes = document.querySelectorAll(".part-checkbox");

		categorySelect.addEventListener("change", (e) => {
			const categoryId = e.target.value;

			QuotesController.cargarPiezasDeSector(categoryId, JSON.parse(localStorage.getItem("newQuoteData")).IdVehiculo).then((parts) => {
				partsTableBody.innerHTML = parts.map(p => `
					<tr class="part-row" data-part-id="${p.id}" data-category-id="${p.categoryId}">
                    <td class="text-center">
                        <input type="checkbox" class="form-check-input part-checkbox" value="${p.id}" data-part-code="${p.code}" data-part-description="${p.description}">
                    </td>
                    <td><code>${p.code}</code></td>
                    <td>${p.description}</td>
                    <td>
                        <input type="number" class="form-control form-control-sm part-quantity" 
                               value="1" min="1" max="99" disabled>
                    </td>
                </tr>
				`).join("");

				QuotesController.setupAddPartModal(); // Re-bind events for new elements
				const rows = document.querySelectorAll(".part-row");

			});
		});

		searchInput.addEventListener("input", (e) => {
			const searchTerm = e.target.value.toLowerCase();
			const rows = document.querySelectorAll(".part-row");

			rows.forEach((row) => {
				const text = row.textContent.toLowerCase();
				row.style.display = text.includes(searchTerm) ? "" : "none";
			});
		});

		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener("change", (e) => {
				const row = e.target.closest(".part-row");
				const quantityInput = row.querySelector(".part-quantity");
				quantityInput.disabled = !e.target.checked;
			});
		});
	},

	cargarPiezasDeSector: async (sectorId, vehicleId) => {
		try {
			const user = AuthService.getCurrentUser();
			const parts = await ApiService.post("vehiculos/ObtenerPiezasPorIdVehiculo_Y_Sector", { IdSector: sectorId, IdVehiculo: vehicleId }, user?.token);

			const partMap = parts.message.map(p => ({
				id: p.pieza_id,
				code: p.NumeroPieza,
				name: p.Descripcion || "",
				description: p.Descripcion || "",
				categoryId: sectorId,
				category: "General",
			}));

			return partMap;
		} catch (error) {
			console.error("Error loading parts by sector:", error);
			Swal.fire("Error", "No se pudieron cargar las piezas del sector seleccionado", "error");
			return [];
		}
	},

	getSelectedParts: () => {
		const selectedParts = [];
		const checkboxes = document.querySelectorAll(".part-checkbox:checked");

		checkboxes.forEach((checkbox) => {
			const row = checkbox.closest(".part-row");
			const quantity = Number.parseInt(row.querySelector(".part-quantity").value);
			const partId = Number.parseInt(checkbox.value);
			const partCode = checkbox.dataset.partCode;
			const partDescription = checkbox.dataset.partDescription;

			selectedParts.push({
				partId: partId,
				quantity: quantity,
				code: partCode,
				description: partDescription
			});
		});

		if (selectedParts.length === 0) {
			Swal.showValidationMessage("Debes seleccionar al menos una pieza");
			return false;
		}

		return selectedParts;
	},

	addPartsToQuote: async (selectedParts) => {

		if (!selectedParts || selectedParts.length === 0) {
			await QuotesController.popupPresupuesto();
			return;
		}

		if (selectedParts.some(p => p.quantity <= 0)) {
			await Swal.fire("Error", "La cantidad de las piezas debe ser mayor a cero", "error");
			await QuotesController.popupPresupuesto();
			return;
		}

		// validate no duplicate parts
		const existingParts = JSON.parse(localStorage.getItem("newQuoteData"))?.items || [];
		const duplicateParts = selectedParts.filter(sp => existingParts.some(ep => ep.partId === sp.partId));
		if (duplicateParts.length > 0) {
			await Swal.fire("Error", `Las siguientes piezas ya fueron agregadas: ${duplicateParts.map(p => p.code).join(", ")}`, "error");
			await QuotesController.popupPresupuesto();
			return;
		}

		localStorage.setItem("newQuoteData", JSON.stringify({
			...JSON.parse(localStorage.getItem("newQuoteData")),
			items: [
				...(JSON.parse(localStorage.getItem("newQuoteData"))?.items || []),
				...selectedParts
			]
		}));

		await QuotesController.popupPresupuesto();
	},

	quitarItem: async (itemId) => {
		const dataCabecera = JSON.parse(localStorage.getItem("newQuoteData")) || [];
		const updatedItems = dataCabecera.items.filter(item => item.partId != itemId);
		localStorage.setItem("newQuoteData", JSON.stringify({
			...dataCabecera,
			items: updatedItems
		}));
		await QuotesController.popupPresupuesto();
	},

};
